import React, { useState, useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { useCartUpdate } from '@hooks';
import { ResponsiveImage } from '@parts';
import classNames from 'classnames';
import { formatCurrency } from '@utils/currency';
import { useQuery } from 'react-query';
import { useUpdateEffect, useMount } from 'ahooks';

const formatProductTitle = (title) => {
  let titleParts = title.split(' - ');
  if (titleParts.length > 1) {
    return (
      <>
        <div>
          <h4 className="card__title">
            <span>{titleParts[1]}</span>
          </h4>
          <h6>{titleParts[0]}</h6>
        </div>
      </>
    );
  } else {
    return (
      <h4 className="card__title">
        <span>{title}</span>
      </h4>
    );
  }
};

const CartLineItem = (props) => {
  const [product, setProduct] = useState(null);
  const { item } = props;
  const queryClient = useQueryClient();
  const ctx = window.app;
  const [quantity, setQuantity] = useState(item.quantity);
  const updateCart = useCartUpdate();

  // fetch product data using react query
  // "/products/safari?variant=41835940053094"
  const { data: productResponse } = useQuery({
    queryKey: ['product', item.product_id],
    queryFn: () => fetch(`${item.url.split('?')[0]}.json?${item.url.split('?')[1]}`).then((res) => res.json()),
  });

  useMount(() => {
    setProduct(item);
  });

  useUpdateEffect(() => {
    let selectedVariant = productResponse.product.variants.find((variant) => variant.id === item.variant_id);
    setProduct({ ...product, compare_at_price: selectedVariant.compare_at_price });
  }, [productResponse]);

  useEffect(() => {
    setQuantity(item.quantity);
  }, [item.quantity]);

  const handleCartRemoval = () => {
    let isBundle = item.properties && Object.keys(item.properties).includes('_bundle_id');
    if (isBundle) {
      let cartItems = window.app.getState().cartContents.items;
      let payload = {};
      cartItems.forEach((cartItem) => {
        if (cartItem.properties._bundle_id === item.properties._bundle_id) {
          payload[cartItem.key] = 0;
        }
      });
      updateCart.mutateAsync({ updates: payload }).then((response) => ctx.emit('cart.update', response.data));
    } else {
      var removeIds = [];
      removeIds.push(item.variant_id);
      let payload = {};
      removeIds.forEach((element) => (payload[element] = 0));
      updateCart.mutateAsync({ updates: payload }).then((response) => ctx.emit('cart.update', response.data));
    }
  };

  const handleQuantityUpdate = (newQuantity) => {
    updateCart.mutateAsync({ updates: { [item.variant_id]: newQuantity } }).then((response) => {
      ctx.emit('cart.update', response.data);
      queryClient.invalidateQueries('cart');
    });
  };

  let renderProductPrice = (item) => {
    if (product && product.compare_at_price !== item.final_line_price) {
      return (
        <div className="discounted-price">
          <small className="previous">{formatCurrency(product.compare_at_price * item.quantity * 100)}</small>
          <span className="newPrice">{formatCurrency(item.final_line_price)}</span>
        </div>
      );
    }
    return formatCurrency(item.final_line_price);
  };

  let filteredOptions = item.options_with_values?.filter((option) => option.value !== 'Default Title');

  return (
    <div className="card" type="cartitem">
      <figure className="card__figure">
        {item.image && <ResponsiveImage image={item.image} title={item.product_title}></ResponsiveImage>}
      </figure>
      <div className="card__details">
        <div className="card__header">
          {formatProductTitle(item.product_title)}
          <div className="amount">{renderProductPrice(item)}</div>
        </div>
        {filteredOptions?.length > 0 && (
          <div className="card__meta">
            <dl className="product-attributes">
              {filteredOptions.map((item) => {
                return (
                  <div key={item.name}>
                    <dt>{item.name}:</dt>
                    <dd>{item.value}</dd>
                  </div>
                );
              })}
            </dl>
          </div>
        )}
        <div className={classNames('quantity_and_amount', { loading: !updateCart.isIdle })}>
          <div className="line-item-options">
            {(!item.properties || !Object.keys(item.properties).includes('_bundle_id')) && (
              <>
                {item.final_price === 0 ? (
                  <div className="qty-input">
                    <span className="quantity">{quantity}</span>
                  </div>
                ) : (
                  <>
                    <div className="qty-input">
                      {/* <span className="multiplier">x</span> */}
                      <div className="qty-input-selector">
                        <button type="button" onClick={() => handleQuantityUpdate(quantity - 1)}>
                          -
                        </button>
                        <span className="quantity">{quantity}</span>
                        <button type="button" onClick={() => handleQuantityUpdate(quantity + 1)}>
                          +
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
          <button className="Button delete-line" data-style="text" data-layout="noLayout" onClick={handleCartRemoval} aria-label="Remove">
            Remove
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartLineItem;
